import _ from 'lodash';
import React from 'react';
import { connect } from 'react-redux';
import ReactTable from 'react-table';

import selectTableHOC from 'react-table/lib/hoc/selectTable';
import LANGUAGES_CONTROLLER from '../../controllers/languages';
import ENUMS, { ErrorKind } from '../../utils/enums';
import NoData from '../page/NoData';
import ActionsPanel from './ActionsPanel';
import ExistingSubCategories from './ExistingSubCategories';
import DisabledActions from './DisabledActions';

import Logger, { LOG_LEVELS } from '../../utils/logger';
import ExportAll from '../common/ExportAll';
import ReadOnlyWrapper from '../authorization/ReadOnlyWrapper';

const FORM_NAME = 'EXISTING_CATEGORIES';
const log = new Logger(FORM_NAME, LOG_LEVELS.DEBUG);

const SelectTable = selectTableHOC(ReactTable);

// Separate component for checkbox input to avoid inline component definition
const SelectInputComponent = (type) => {
    return (
        <ReadOnlyWrapper>
            <fieldset className="SelectTable">
                <input
                    className='mt5 checkbox'
                    type={'checkbox'}
                    checked={type.checked}
                    onClick={(e) => {
                        const { shiftKey } = e;
                        e.stopPropagation();
                        type.onClick(type.id, shiftKey, type.row);
                    }}
                    onChange={() => { }}
                />
                <label className="mt5 checkbox"></label>
            </fieldset>
        </ReadOnlyWrapper>
    );
};

const NoDataComponent = (props) => {
    return (
        <NoData noDataText="errorAndWarnings_NoData" {...props} />
    );
};

const recordCounter = (prevValue, currentValue) => prevValue + currentValue.totalItemsCount;
class ExistingCategories extends React.Component {

    constructor(props) {
        super(props);
        //Local state      
        this.state = {
            errorData: props.errorData || [],
            warningData: props.warningData || [],
            errorExpanded: {},
            warningExpanded: {},
            errorSelection: new Map(),
            errorSelectAll: false,
            warningSelection: new Map(),
            warningSelectAll: false,
            selectedAction: props.selectedAction || 'select',
            selectedErrorCount: 0,
            selectedWarningCount: 0,
            defaultErrorPageSize: 1000,
            defaultWarningPageSize: 1000,
            transactionsForClosedFiling: false,
            disabledActions: [],
            selectedCategory: null
        };
        this.onCategoryToggleHandler = this.onCategoryToggleHandler.bind(this);
        this.onErrorExpandedChange = this.onErrorExpandedChange.bind(this);
        this.onWarningExpandedChange = this.onWarningExpandedChange.bind(this);
        this.onSubCategoryActionClick = this.onSubCategoryActionClick.bind(this);
        this.onSubCategoryFetchData = this.onSubCategoryFetchData.bind(this);
        this.toggleExpanded = this.toggleExpanded.bind(this);
        this.toggleSelection = this.toggleSelection.bind(this);
        this.toggleAll = this.toggleAll.bind(this);
        this.isSelected = this.isSelected.bind(this);
        this.errorWarningCategoryActionHandler = this.errorWarningCategoryActionHandler.bind(this);
        this.onDisabledActionsChanged = this.onDisabledActionsChanged.bind(this);
        this.handleExportErrorWarningToCSV = this.handleExportErrorWarningToCSV.bind(this);
        this.getLanguageText = this.getLanguageText.bind(this);
        this.getToastDetails = this.getToastDetails.bind(this);
        this.handleToastClose = this.handleToastClose.bind(this);
        this.renderExportAll = this.renderExportAll.bind(this);
        this.updateErrorTypeSelection = this.updateErrorTypeSelection.bind(this);
    }

    handleExportErrorWarningToCSV(totalErrors, totalWarnings) {
        const params = {
            totalCount: totalErrors + totalWarnings,
            errorCount: totalErrors,
            warningCount: totalWarnings,
            includeError: totalErrors > 0,
            includeWarning: totalWarnings > 0
        };
        this.props.onExportAllToCSVClick(params);
    }

    handleToastClose() {
        this.props.onResetToastClick();
    }

    getLanguageText(languages, key) {
        return this.props.showToast && languages && LANGUAGES_CONTROLLER.formatUtilFormatter(languages.data, key);
    }

    getToastDetails() {
        return (this.props.exportResponse && !this.props.exportResponse?.isSuccess) ? this.props.exportResponse?.error.message : this.getLanguageText(this.props.languages, 'viewTransmission_ExportAllToastDetails')
    }

    onDisabledActionsChanged(disabledActions) {
        this.setState({ disabledActions: disabledActions });
    }

    onErrorExpandedChange(expanded, index, event) {
        this.setState({ errorExpanded: expanded });
    }

    onWarningExpandedChange(expanded, index, event) {
        this.setState({ warningExpanded: expanded });
    }

    toggleExpanded(expanded, index) {
        if (typeof expanded[index] === 'undefined') {
            let expand = {};
            expand[index] = {};
            return Object.assign({}, expanded, expand);
        } else if (expanded[index] === false) {
            let expand = {};
            expand[index] = {};
            return Object.assign({}, expanded, expand);
        } else {
            let expand = {};
            expand[index] = false;
            return Object.assign({}, expanded, expand);
        }
    }

    updateErrorTypeSelection(isErrorType, key, row) {
        let selectedErrorCount = this.state.selectedErrorCount;
        let selectedWarningCount = this.state.selectedWarningCount;
        let selection = new Map(isErrorType ? this.state.errorSelection : this.state.warningSelection);
        const matchKey = 'select-';
        let aliasKey = `${key}`.includes(matchKey) ? `${key}`.replace(matchKey, '') : `${matchKey}${key}`;
        let selectedFilingType = null;
        const isKeyExist = selection.has(key) || selection.has(aliasKey) || selection.has(parseInt(aliasKey, 10));
        if(isKeyExist) {
            selection.delete(key);
            if (isErrorType) {
                selectedErrorCount = this.state.selectedErrorCount - (row?.totalItemsCount || 0);
            } else {
                selectedWarningCount = this.state.selectedWarningCount - (row?.totalItemsCount || 0);
            }
            this.setState({
                selectedCategory: null
            });
        } else {
            selection.set(key);
            if (isErrorType) {
                selectedErrorCount = this.state.selectedErrorCount + (row?.totalItemsCount || 0);
            } else {
                selectedWarningCount = this.state.selectedWarningCount + (row?.totalItemsCount || 0);
            }
            this.setState({
                selectedCategory: row
            });
            selectedFilingType = ENUMS.getFilingTypeFromSubType(row.subType);
        }
        return {
            selection,
            selectedErrorCount,
            selectedWarningCount,
            selectedFilingType
        }
    }

    toggleSelection(errorType) {
        return (key, shift, row) => {
            log.debug('toggleSelection(): ', key, row);
            let isErrorType = errorType === ErrorKind.ERROR;
            // If the selected rows error code is for 'transactions for closed filing' then set boolean state value
            this.setState({ errorCodeId: row.codeId });
            /*
            Implementation of how to manage the selection state is up to the developer.
            This implementation uses an array stored in the component state.
            Other implementations could use object keys, a Javascript Set, or Redux... etc.
            */
            // start off with the existing state
            const {selection, selectedFilingType, selectedErrorCount, selectedWarningCount} = this.updateErrorTypeSelection(isErrorType, key, row);

            if (isErrorType) {
                this.setState({
                    errorSelection: selection,
                    selectedErrorCount: selectedErrorCount,
                });
            } else {
                this.setState({
                    warningSelection: selection,
                    selectedWarningCount: selectedWarningCount
                });
            }

            if (selection.size === 1) {
                // The currently selected row might not be the last row clicked. 
                // It might be that the current row is un-clicked and one remaining row is still checked.
                // This means that the id should be found for the error that is checked,
                // so look it up based on the value guid
                var checkedErrorRow = this.state.errorData.find(x => x._id === selection.keys().next().value);
                this.setState({ errorCodeId: checkedErrorRow.codeId });
            }
            else {
                this.setState({ errorCodeId: undefined });
            }

            if (typeof this.props.onSelectionChange === 'function') {
                this.props.onSelectionChange(selection, errorType, selectedErrorCount || 0, selectedWarningCount || 0, selectedFilingType);
            }
        };
    }

    toggleAll(errorType) {
        return () => {
            log.debug('toggleAll(): ');
            let selectAll, viewTable;
            if (errorType === ErrorKind.ERROR) {
                selectAll = this.state.errorSelectAll ? false : true;
                viewTable = this.errorViewTable;
            } else {
                selectAll = this.state.warningSelectAll ? false : true;
                viewTable = this.warningViewTable;
            }
            let selection = new Map();
            if (selectAll) {
                // we need to get at the internals of ReactTable
                const wrappedInstance = viewTable.getWrappedInstance();
                // the 'sortedData' property contains the currently accessible records based on the filter and sort
                const currentRecords = wrappedInstance.getResolvedState().sortedData;
                // we just push all the IDs onto the selection array
                currentRecords.forEach(item => {
                    if (item._original) {
                        selection.set(item._original._id);
                    }
                });
            }
            log.debug('toggleAll(): selectAll: ', selectAll);
            log.debug('toggleAll(): selection: ', selection);
            if (errorType === ErrorKind.ERROR) {
                this.setState({ errorSelectAll: selectAll, errorSelection: selection });
            } else {
                this.setState({ warningSelectAll: selectAll, warningSelection: selection });
            }
        }
    }

    isSelected(errorType) {
        return (key) => {
            log.debug('isSelected(): key: ', key);
            let selection = (errorType === ErrorKind.ERROR ? this.state.errorSelection : this.state.warningSelection);
            let aliasKey = `${key}`.includes('select-') ? `${key}`.replace('select-', '') : `select-${key}`;
            log.debug('isSelected(): aliasKey: ', aliasKey);
            let isKeySelected = selection.has(key) || selection.has(aliasKey) || selection.has(parseInt(aliasKey, 10));
            log.debug('isSelected(): isKeySelected: ', isKeySelected);
            return isKeySelected;
        }
    }

    onCategoryToggleHandler(type) {

        return (state, rowInfo, instance) => {
            log.debug('onCategoryToggleHandler(): ', state, rowInfo, instance);
            return {
                onClick: (e, handleOriginal) => {
                    // IMPORTANT! React-Table uses onClick internally to trigger
                    // events like expanding SubComponents and pivots.
                    // By default a custom 'onClick' handler will override this functionality.
                    // If you want to fire the original onClick handler, call the
                    // 'handleOriginal' function.
                    if (typeof this.props.onCategoryToggle === 'function') {
                        if (ErrorKind.ERROR === type) {
                            let expanded = this.toggleExpanded(state.expanded, rowInfo.index);
                            this.onErrorExpandedChange(expanded, rowInfo.index);
                        } else if (ErrorKind.WARNING === type) {
                            let expanded = this.toggleExpanded(state.expanded, rowInfo.index);
                            this.onWarningExpandedChange(expanded, rowInfo.index);
                        }
                    }
                }
            };
        };
    }

    errorWarningCategoryActionHandler(requestedAction) {
        this.setState({
            selectedAction: requestedAction ? requestedAction.value : 'select'
        });
        if (typeof this.props.onCategoryActionClick === 'function') {
            let errorType, selection;
            if (_.isEmpty(this.state.errorSelection)) {
                errorType = ErrorKind.WARNING;
                selection = this.state.warningSelection;
            } else {
                errorType = ErrorKind.ERROR;
                selection = this.state.errorSelection;
            }
            this.props.onCategoryActionClick(requestedAction, errorType, selection, this.state.selectedCategory);
        }
    }

    onSubCategoryActionClick(row) {
        return (type, action, data, event) => {
            if (typeof this.props.onActionClick === 'function') {
                this.props.onActionClick(type, action, data, event, row);
            }
        }
    }

    defaultSelectInputComponent() {
        return SelectInputComponent;
    }
    onSubCategoryFetchData(pagination, errorCategoryRowData) {
        this.props.onFetchData(pagination, errorCategoryRowData);
    }

    renderExportAll(totalErrors, totalWarnings) {
        return(totalErrors > 0 || totalWarnings > 0) &&
            <div className='float-right' style={{zIndex: 99}}>
                <ExportAll
                    exportLabel='viewTransmission_ExportAllToCSV'
                    exportClick={() => this.handleExportErrorWarningToCSV(totalErrors, totalWarnings)}
                    exportFor='ENABLE_EXPORT_ALL_ERRORS_WARNINGS'
                    showToast={!!this.props.showToast}
                    elementType='btn'
                    toastType={(this.props.exportResponse && !this.props.exportResponse?.isSuccess) ? this.props.exportResponse?.error.type : 'success'}
                    toastTitle={this.getLanguageText(this.props.languages, 'viewTransmission_ExportAllToastTitle')}
                    toastDetails={this.getToastDetails()}
                    onCloseClick={this.handleToastClose}
                />
            </div>
    }

    render() {
        log.debug('render(): ', this.props);
        const errorData = this.state.errorData || [];
        const totalErrors = errorData.reduce(recordCounter, 0);
        const errorTableOptions = Object.assign({}, this.props.tableOptions, {
            expanded: this.state.errorExpanded,
            selectAll: this.state.errorSelectAll,
            isSelected: this.isSelected(ErrorKind.ERROR),
            toggleAll: this.toggleAll(ErrorKind.ERROR),
            toggleSelection: this.toggleSelection(ErrorKind.ERROR),
            keyField: "_id",
            sortable: false,
            selectType: "checkbox",
            SelectInputComponent: this.defaultSelectInputComponent()
        });

        const warningData = this.state.warningData || [];
        const totalWarnings = warningData.reduce(recordCounter, 0);
        const warningTableOptions = Object.assign({}, this.props.tableOptions, {
            expanded: this.state.warningExpanded,
            selectAll: this.state.warningSelectAll,
            isSelected: this.isSelected(ErrorKind.WARNING),
            toggleAll: this.toggleAll(ErrorKind.WARNING),
            toggleSelection: this.toggleSelection(ErrorKind.WARNING),
            keyField: "_id",
            sortable: false,
            selectType: "checkbox",
            SelectInputComponent: this.defaultSelectInputComponent()
        });
        const getColumns = (type) => {
            return [
                {
                    expander: true,
                    width: 30,
                    Expander: ({ isExpanded, ...rest }) => {
                        return (
                            <div>{isExpanded ? <span><s-icon name="chevron-down"></s-icon></span> : <span><s-icon name="chevron-down"></s-icon></span>}</div>
                        );
                    }
                },
                {
                    headerClassName: 'invisible',
                    Header: row => (
                        <div>
                            {
                                type === ErrorKind.ERROR ? (
                                    <h2>
                                        {LANGUAGES_CONTROLLER.format(this.props.languages, "existingCategories_Errors")}
                                        <div className="ml20 display-inline">
                                            {totalErrors === 0 ? '' : `${totalErrors}`}
                                        </div>
                                    </h2>
                                ) :
                                    (
                                        <h2>
                                            {LANGUAGES_CONTROLLER.format(this.props.languages, "existingCategories_Warnings")}
                                            <div className="ml20 display-inline">
                                                {totalWarnings === 0 ? '' : `${totalWarnings}`}
                                            </div>
                                        </h2>
                                    )
                            }
                        </div>
                    ),
                    accessor: 'subType',
                    className: 'clickable',
                    Cell: row => (
                        <div>
                            <span className="bold">{`${row.value}`}</span>
                            <span className='ml30'>{`${row.original.totalItemsCount}`}</span>
                        </div>
                    )
                }
            ]
        };

        const disableActionPanel =
            (_.isEmpty(this.state.errorSelection) && _.isEmpty(this.state.warningSelection))
            || (!_.isEmpty(this.state.errorSelection) && !_.isEmpty(this.state.warningSelection))
            || this.state.errorSelection.size > 1
            || this.state.warningSelection.size > 1
            || this.props.disableActions;

        return (
            <div>
                <div className="mb10">
                    <ActionsPanel
                        onAction={this.errorWarningCategoryActionHandler}
                        disable={this.state.disabledActions}
                        selectedValue={this.state.selectedAction}
                        disableAll={disableActionPanel}
                    />
                </div>
                <div className='ReactTableList'>
                    <hr />
                    {this.renderExportAll(totalErrors, totalWarnings)}
                    <div className={this.props.showErrors ? '' : 'invisible'} data-test="error-table">
                        <h3 className="alt bold">
                            {LANGUAGES_CONTROLLER.format(this.props.languages, "existingCategories_Errors")}
                            <div className="ml20 display-inline" data-test="error-count">
                                {totalErrors === 0 ? '' : `${totalErrors}`}
                            </div>
                        </h3>
                        <br />
                        <SelectTable
                            minRows={0}
                            maxRows={0}
                            ref={(r) => this.errorViewTable = r}
                            defaultPageSize={this.state.defaultErrorPageSize}
                            data={errorData}
                            columns={getColumns(ErrorKind.ERROR)}
                            getTrProps={this.onCategoryToggleHandler(ErrorKind.ERROR)}
                            defaultFilterMethod={(filter, row) => String(row[filter.id]).includes(filter.value)}
                            {...errorTableOptions}
                            NoDataComponent={NoDataComponent}
                            SelectAllInputComponent={'span'}
                            showPagination={false}
                            loading={this.props.loading}
                            SubComponent={row => {
                                return (
                                    <ExistingSubCategories
                                        type={ErrorKind.ERROR}
                                        categoryRowData={row}
                                        onFetchData={this.onSubCategoryFetchData}
                                        onActionClick={this.onSubCategoryActionClick(row)}
                                        loading={this.props.subCategoriesLoading[row.index]}
                                    />
                                );
                            }
                            }
                        />
                    </div>
                    <div className={this.props.showWarnings ? (this.props.showErrors ? 'mt20' : '') : 'invisible'}>
                        <h3 className="alt bold">
                            {LANGUAGES_CONTROLLER.format(this.props.languages, "existingCategories_Warnings")}
                            <div className="ml20 display-inline">
                                {totalWarnings === 0 ? '' : `${totalWarnings}`}
                            </div>
                        </h3>
                        <br />
                        <SelectTable
                            minRows={0}
                            maxRows={0}
                            ref={(r) => this.warningViewTable = r}
                            data={warningData}
                            columns={getColumns(ErrorKind.WARNING)}
                            getTrProps={this.onCategoryToggleHandler(ErrorKind.WARNING)}
                            defaultFilterMethod={(filter, row) => String(row[filter.id]).includes(filter.value)}
                            {...warningTableOptions}
                            NoDataComponent={NoDataComponent}
                            SelectAllInputComponent={'span'}
                            showPagination={false}
                            loading={this.props.loading}
                            SubComponent={row => {
                                return (
                                    <ExistingSubCategories
                                        type={ErrorKind.WARNING}
                                        categoryRowData={row}
                                        onFetchData={this.onSubCategoryFetchData}
                                        onActionClick={this.onSubCategoryActionClick(row)}
                                        loading={this.props.subCategoriesLoading[row.index]}
                                    />
                                );
                            }
                            }
                            defaultPageSize={this.state.defaultWarningPageSize}
                        />
                    </div>
                </div>
                <DisabledActions
                    disabledActionsChanged={this.onDisabledActionsChanged}
                    errorsSelection={this.state.errorSelection}
                    warningsSelection={this.state.warningSelection}
                    errorCodeId={this.state.errorCodeId}
                    totalItemsCount={this.state.selectedCategory?.totalItemsCount}
                    selectedFilingType={this.props.selectedFilingType} />
            </div>
        );
    }

    componentDidUpdate(prevProps) {
        if (this.props.errorData !== prevProps.errorData) {
            if (_.isEmpty(this.props.errorData)) {
                this.setState({
                    errorExpanded: {}
                });
            }
            this.setState({
                errorData: this.props.errorData,
                errorSelection: new Map(),
                errorSelectAll: false,
                selectedAction: 'select',
                selectedErrorCount: 0,
                defaultErrorPageSize: this.props.errorData ? this.props.errorData.length : 1000,
                subCategoriesLoading: []
            });
        }
        if ((this.props.warningData !== prevProps.warningData)) {
            if (_.isEmpty(this.props.warningData)) {
                this.setState({
                    warningExpanded: {},
                });
            }
            this.setState({
                warningData: this.props.warningData,
                warningSelection: new Map(),
                warningSelectAll: false,
                selectedAction: 'select',
                selectedWarningCount: 0,
                defaultWarningPageSize: this.props.warningData ? this.props.warningData.length : 1000,
                subCategoriesLoading: []
            });
        }
        if ((this.props.collapseAll !== prevProps.collapseAll) && this.props.collapseAll) {
            this.setState({
                errorExpanded: {},
                warningExpanded: {},
                subCategoriesLoading: []
            });
        }
        if (this.props.selectedAction !== prevProps.selectedAction) {
            this.setState({
                selectedAction: this.props.selectedAction
            });
        }
    }
}


ExistingCategories.defaultProps = {
    errorData: [],
    warningData: [],
    showErrors: true,
    showWarnings: true,
    onActionClick: () => { },
    onCategoryToggle: () => { },
    onFetchData: () => { },
    onCategoryActionClick: () => { },
    collapseAll: false,
    keyField: '_id',
    onSelectionChange: () => { },
    loading: false,
    disableActions: true,
    subCategoriesLoading: [],
    onExportAllToCSVClick: () => {},
    onResetToastClick: () => {},
};

function mapStateToProps(state) {
    log.debug('mapStateToProps(): ');
    let stateProps = {};
    stateProps.languages = state.languages;
    stateProps.showToast = state.errorsWarnings?.showToast;
    stateProps.exportResponse = state.errorsWarnings?.exportResponse;
    stateProps.featureFlags = state.featureFlag?.data;
    log.debug('mapStateToProps(): stateProps: ', stateProps);
    return stateProps;
}

function mapDispatchersToProps(dispatch) {
    log.debug('mapDispatchersToProps(): ');
    let dispatcherProps = {};
    log.debug('mapDispatchersToProps(): dispatcherProps: ', dispatcherProps);
    return dispatcherProps;
}

export default connect(mapStateToProps, mapDispatchersToProps)(ExistingCategories);
